module.exports = __webpack_public_path__ + "img/math-1.f1a0eb66.png";